module.exports = __webpack_public_path__ + "img/377d74e.png";